<template>
  <div class="redEnvelopes">
    <div>
      <div class="item">
        <span style="color:red">*</span>
        <span class="text">平台</span>
        <el-select v-model="parameter.platform_id" filterable placeholder="请选择平台">
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <span style="color:red">*</span>
        <span class="text">活动名称</span>
        <el-input v-model="parameter.act_name" placeholder="请输入活动名称" />
      </div>
      <div class="item">
        <span style="color:red">*</span>
        <span class="text">金额类型</span>
        <el-select v-model="parameter.amount_type" placeholder="请选择" @change="amounttyperew">
          <el-option
            v-for="item in amount_types"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div v-if="parameter.amount_type == 1" class="item">
        <span style="color:red">*</span>
        <span class="text">固定红包金额</span>
        <el-input v-model="parameter.total_amount" min="0.3" max="200" placeholder="请输入固定金额" type="number" @blur="smawerdaswrw" />
      </div>
      <div v-if="parameter.amount_type == 2" class="item">
        <span style="color:red">*</span>
        <span class="text">随机金额</span>
        <div style="display: flex;">
          <div style="margin-right:20px">
            <span>最小值</span>
            <el-input v-model="mini" placeholder="最小值" min="0.3" max="200" style="width: 100px;margin-left:10px" type="number" @blur="smawer" />
          </div>
          <div>
            <span>最大值</span>
            <el-input v-model="max" placeholder="最大值" min="0.3" max="200" style="width: 100px;margin-left:10px" type="number" @blur="smawerrw" />
          </div>
        </div>
      </div>
      <div class="item">
        <span style="color:red">*</span>
        <span class="text">祝福语</span>
        <el-input v-model="parameter.wishing" placeholder="请输入祝福语" />
      </div>

      <div class="item">
        <span style="color:red">*</span>
        <span class="text">备注信息</span>
        <el-input v-model="parameter.remark" placeholder="请输入备注信息" />
      </div>

      <div class="item">
        <span style="color:red">*</span>
        <span class="text">日期</span>
        <el-date-picker
          v-model="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
      </div>

      <div class="item">
        <span style="color:red">*</span>
        <span class="text">发放总数</span>
        <el-input v-model="parameter.total" placeholder="请输入金额" type="number" />
      </div>

      <!-- <div class="item">
        <span class="text">用户标签</span>
        <el-input v-model="parameter.tag_ids" placeholder="请输入金额" />
      </div> -->

      <div class="item">
        <span style="color:red">*</span>
        <span class="text">用户标签组id</span>
        <el-select v-model="parameter.tag_group_id" filterable placeholder="请选择平台">
          <el-option
            v-for="item in tag_groups"
            :key="item.id"
            :label="item.tag_group_name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>
    <div
      style="text-align: end; margin-top: 20px;"
    >
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { strategyPlatform } from '@/api/sourceMaterial.js'
import { getList } from '@/api/labelGroup.js'
export default {
  data() {
    return {
      parameter: {
        platform_id: null, // 平台ID
        total_amount: null, // 固定红包金额
        wishing: null, // 祝福语
        act_name: null, // 活动名称
        remark: null, // 备注信息
        start_time: null, // 开始时间
        end_time: null, // 结束时间
        amount_random: null, // 随机金额
        amount_type: null, // 1 固定金额 2随机金额
        total: null, // 发放总数
        // tag_ids: null, // 用户标签
        tag_group_id: null // 标签组id
      },
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      mini: null, // 最小值
      max: null, // 最大值
      date: [],
      platforms: [],
      tag_groups: [],
      amount_types: [{ id: 1, value: '固定金额' }, { id: 2, value: '随机金额' }]
    }
  },
  created() {
    this.getPlatform()
    this.getLabel()
  },
  methods: {
    // 获取平台
    async getPlatform() {
      const data = await strategyPlatform()
      this.platforms = data.data.list
    },

    async getLabel() {
      const data = await getList()
      this.tag_groups = data.data.list
      this.tag_groups.unshift({
        id: 0,
        tag_group_name: '全部'
      })
    },

    determine() {
      if (this.date && this.date.length) {
        this.parameter.start_time = this.date[0]
        this.parameter.end_time = this.date[1]
      }
      this.parameter.amount_random = [this.mini, this.max]
      this.$emit('determine', this.parameter)
    },
    amounttyperew(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        console.log('固定')
        this.mini = null
        this.max = null
        this.parameter.amount_random = null
      } else {
        console.log('随机')
        this.parameter.total_amount = null
      }
    },
    smawer() {
      if (this.mini < 0.3) {
        this.mini = 0.3
      }
      if (this.mini > 200) {
        this.mini = 0.3
      }
    },
    smawerrw() {
      if (this.max < 0.3) {
        this.max = 200
      }
      if (this.max > 200) {
        this.max = 200
      }
    },
    smawerdaswrw() {
      if (this.parameter.total_amount < 0.3) {
        this.parameter.total_amount = 0.3
      }
      if (this.parameter.total_amount > 200) {
        this.parameter.total_amount = 200
      }
    }
  }
}
</script>

<style scoped>
.redEnvelopes{

}
.item{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.item .text{
    width: 100px;
    display: inline-block;
}
.el-input{
  width: 203px;
}
@media (max-width: 768px){
  .item .text{
    font-size:3vw;
  }
}
</style>
